/* bt-kontakt-kontext.js · 01.09.2026
   Gibt dem Kontakt-Popup den fehlenden Kontext.

   Ausgangslage: cdx-header.js fuellt beim Oeffnen bereits contact[Seite] mit
   der vollen URL, contact[Seitentitel] mit dem Seitentitel und
   contact[Referrer] mit document.referrer. Der Link ist damit schon in der
   Mail. Was fehlte:

   1. Woher der Kunde geklickt hat. Header und Produktseite oeffnen dasselbe
      Popup, in der Mail sah beides gleich aus.
   2. Um welches Produkt es geht, wenn aus der Beratungsbox geschrieben wird.
   3. Wie der Kunde ueberhaupt auf die Seite gekommen ist. document.referrer
      ist dafuer wertlos, sobald er einmal intern weitergeklickt hat, dann
      steht dort die eigene Seite. UTM-Parameter waren gar nicht erfasst.

   Erst- und Letztkontakt werden getrennt gehalten. Der Erstkontakt sagt,
   welcher Kanal den Kunden gebracht hat, und wird nie ueberschrieben. Der
   Letztkontakt sagt, welcher Kanal ihn zurueckgeholt hat. Beides steht im
   localStorage, also nur im Browser des Kunden, und wird ausschliesslich beim
   Absenden einer Nachricht mitgeschickt.

   Neue Felder in der Mail:
     contact[Herkunft]        Header oder Produktseite
     contact[Produkt]         nur bei Herkunft Produktseite
     contact[Artikelnummer]   nur bei Herkunft Produktseite und vorhandener SKU
     contact[Quelle]          letzter Kanal, zum Beispiel google / cpc
     contact[Kampagne]        utm_campaign, dazu term und content
     contact[Erstkontakt]     erster Kanal mit Datum und Einstiegsseite

   Leere Felder werden auf disabled gesetzt und damit nicht mitgeschickt,
   sonst stehen in jeder Mail leere Zeilen. */

(function () {
  if (window.__btKontaktKontext) return;
  window.__btKontaktKontext = true;

  var ERST = 'bt_erstkontakt';
  var LETZT = 'bt_letztkontakt';
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var KLICK = ['gclid', 'msclkid', 'fbclid', 'ttclid'];

  function lies(schluessel) {
    try { return JSON.parse(localStorage.getItem(schluessel) || 'null'); }
    catch (e) { return null; }
  }
  function schreib(schluessel, wert) {
    try { localStorage.setItem(schluessel, JSON.stringify(wert)); } catch (e) {}
  }

  function verweisHost() {
    try { return new URL(document.referrer).hostname.replace(/^www\./, ''); }
    catch (e) { return ''; }
  }

  /* Kanal aus der aktuellen Adresse ableiten. Gibt null zurueck, wenn dieser
     Seitenaufruf gar keine Herkunft traegt, also interne Navigation ist. */
  function kanal() {
    var p;
    try { p = new URLSearchParams(location.search); } catch (e) { return null; }

    var daten = { quelle: '', medium: '', kampagne: '', begriff: '', inhalt: '', klick: '' };
    var hatUtm = false;
    UTM.forEach(function (k) {
      var v = p.get(k);
      if (!v) return;
      hatUtm = true;
      if (k === 'utm_source') daten.quelle = v;
      else if (k === 'utm_medium') daten.medium = v;
      else if (k === 'utm_campaign') daten.kampagne = v;
      else if (k === 'utm_term') daten.begriff = v;
      else daten.inhalt = v;
    });
    KLICK.forEach(function (k) { if (!daten.klick && p.get(k)) daten.klick = k + '=' + p.get(k); });

    var host = verweisHost();
    var extern = host && host !== location.hostname.replace(/^www\./, '');

    if (!hatUtm && !daten.klick) {
      if (!extern) return null;
      daten.quelle = host;
      daten.medium = 'referral';
    }
    daten.einstieg = location.pathname;
    daten.zeit = new Date().toISOString().slice(0, 10);
    return daten;
  }

  function merken() {
    var jetzt = kanal();
    if (!jetzt) {
      /* Kein Erstkontakt gespeichert und keine Herkunft erkennbar: der Kunde
         ist direkt gekommen. Einmal festhalten, damit spaeter nicht ein
         interner Klick faelschlich als Erstkontakt gilt. */
      if (!lies(ERST)) {
        schreib(ERST, {
          quelle: 'direkt', medium: 'direkt', kampagne: '', begriff: '', inhalt: '', klick: '',
          einstieg: location.pathname,
          zeit: new Date().toISOString().slice(0, 10)
        });
      }
      return;
    }
    if (!lies(ERST)) schreib(ERST, jetzt);
    schreib(LETZT, jetzt);
  }

  function alsText(d) {
    if (!d) return '';
    var t = (d.quelle || 'direkt') + ' / ' + (d.medium || 'direkt');
    if (d.klick) t += ' (' + d.klick + ')';
    return t;
  }

  /* Verstecktes Feld anlegen oder wiederverwenden */
  function feld(form, name) {
    var el = form.querySelector('input[name="contact[' + name + ']"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'contact[' + name + ']';
      el.setAttribute('data-bt-kk', '');
      form.appendChild(el);
    }
    return el;
  }
  function setze(form, name, wert) {
    var el = feld(form, name);
    el.value = wert || '';
    el.disabled = !wert;
  }

  function fuellen(ausloeser) {
    var host = document.querySelector('[data-contact-host]');
    if (!host) return;
    var form = host.querySelector('.cdx-hd__contact-form');
    if (!form) return;

    var imHeader = !!(ausloeser && ausloeser.closest &&
      ausloeser.closest('header, .cdx-hd, [data-contact-host], [id*="header" i]'));

    var block = host.querySelector('[data-bt-kk-produkt]');
    var zeigeProdukt = !!block && !imHeader && !!ausloeser;

    if (block) block.hidden = !zeigeProdukt;

    setze(form, 'Herkunft', imHeader ? 'Header' : (zeigeProdukt ? 'Produktseite' : 'Seiteninhalt'));
    setze(form, 'Produkt', zeigeProdukt ? block.getAttribute('data-bt-titel') : '');
    setze(form, 'Artikelnummer', zeigeProdukt ? block.getAttribute('data-bt-sku') : '');

    var letzt = lies(LETZT);
    var erst = lies(ERST);
    setze(form, 'Quelle', alsText(letzt || erst));

    var kampagne = '';
    var k = letzt || erst;
    if (k && k.kampagne) {
      kampagne = k.kampagne;
      if (k.begriff) kampagne += ' | Begriff: ' + k.begriff;
      if (k.inhalt) kampagne += ' | Motiv: ' + k.inhalt;
    }
    setze(form, 'Kampagne', kampagne);

    var erstText = '';
    if (erst) {
      erstText = alsText(erst);
      if (erst.zeit) erstText += ' am ' + erst.zeit;
      if (erst.einstieg) erstText += ', Einstieg ' + erst.einstieg;
    }
    setze(form, 'Erstkontakt', erstText);
  }

  merken();

  /* In der Capture-Phase mitlesen, welcher Ausloeser geklickt wurde.
     cdx-header.js oeffnet das Popup im selben Klick, ohne den Ausloeser
     weiterzureichen. Das setTimeout laeuft danach, dann stehen die von
     cdx gesetzten Felder schon und werden nicht ueberschrieben. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('[data-action="open-contact"]');
    if (!a) return;
    setTimeout(function () { fuellen(a); }, 0);
  }, true);
})();

/* 18.09.2026, Design und Umsetzung: Nach dem Blaettern oder Filtern auf Kategorien oben am
   Produktraster landen. Eigener Block, hat mit dem Kontakt-Popup nichts zu tun, steht nur hier,
   weil diese Datei auf jeder Seite laedt.

   Ursache: theme.js (CollectionSection._reload) laedt das Raster per AJAX nach und will danach
   zum Raster scrollen. Die Rechnung nutzt --header-is-sticky und --header-height, die nur der alte
   Standard-Kopf gesetzt hat. Unter dem cdx-Kopf sind beide leer, das Ergebnis ist NaN und der
   Sprung faellt aus. Man bleibt unten an der Seitenleiste stehen, bei kuerzeren Folgeseiten
   sogar im Footer. Die Variablen werden bewusst nicht global gesetzt, weil theme.css sie auch
   fuer Werkzeugleiste, Anker und Suche nutzt.

   Ablauf: Klick auf eine Seitenzahl, auf Filter zuruecksetzen oder Aenderung eines Filters in der
   Collection- oder Such-Section merken. Beim naechsten theme:loading:end (feuert theme.js nach dem
   Austausch des Rasters) zum Raster scrollen, knapp unter den Kopf, nur wenn es oberhalb steht. */
(function () {
  if (window.__btKategorieScroll) return;
  window.__btKategorieScroll = true;

  var SECTION = '[data-section-type="collection"], [data-section-type="search"]';
  var wartet = false;

  function merken(e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest(SECTION)) return;
    if (e.type === 'click') {
      if (t.closest('.pagination [data-page], [data-action="clear-filters"]')) wartet = true;
    } else if (t.name && t.name.indexOf('filter.') === 0) {
      wartet = true;
    }
  }
  document.addEventListener('click', merken, true);
  document.addEventListener('change', merken, true);

  function kopfUnten() {
    var kopf = document.querySelector('.cdx-hd');
    if (!kopf) return 0;
    var pos = getComputedStyle(kopf).position;
    if (pos !== 'fixed' && pos !== 'sticky') return 0;
    return Math.max(0, Math.round(kopf.getBoundingClientRect().bottom));
  }
  function abstand() {
    var ziel = document.querySelector(SECTION.split(', ').map(function (s) { return s + ' .collection'; }).join(', '));
    if (!ziel) return 0;
    return Math.round(ziel.getBoundingClientRect().top - kopfUnten() - 16);
  }

  document.addEventListener('theme:loading:end', function () {
    if (!wartet) return;
    wartet = false;
    var d = abstand();
    if (d >= 0) return;
    window.scrollBy(0, d);
    /* Der cdx-Kopf aendert beim Scrollen seine Hoehe. Einmal nachmessen und angleichen. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var d2 = abstand();
        if (Math.abs(d2) > 4) window.scrollBy(0, d2);
      });
    });
  });
})();
